import templateUrl from 'emun.vendor/vendor-api-key.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import ServiceBus from 'servicestack/service-bus'
import modals from 'webmodals/modals'

class VendorApiKeyController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		    $ctrl.bus = new ServiceBus();
        if ($ctrl.$session.isRetailer && !$ctrl.vendorId) $ctrl.vendorId = $ctrl.$session.retailerId;
        $ctrl.bus
        .send("QueryVendors.json?Active=1&Id=" + $ctrl.vendorId)
        .then(function(res) {
          if (res.data.results.length > 0) $ctrl.vendor = res.data.results[0];
        });
        $ctrl.getApiKey();
    }
    getApiKey() {
      const $ctrl = this;
      $ctrl.bus.send("GetVendorApiKey", {
        VendorId: $ctrl.vendorId
      }).then(function(res) {
        if (res.data.apiKeys && res.data.apiKeys.length) $ctrl.apiKey = res.data.apiKeys[0].id;
      })
    }
    generateApiKey() {
      const $ctrl = this;
      $ctrl.bus.send("AWS/GenerateVendorApiKey", {
        VendorId: $ctrl.vendorId
      }).then(function(res) {
        if (res.data.apiKeys.length) {
          $ctrl.apiKey = res.data.apiKeys[0].id;
          // $ctrl.bus.send("AWS/Createsecret.json", {
          //   SecretName: "APIKEY/" + $ctrl.vendorId,
          //   SecretDescription: "APIKEY:" + $ctrl.vendorId,
          //   SecretPayload: {
          //     apiKey: $ctrl.apiKey
          //   }
          // });
        }
      })
    }
    togglePw() {
      const $ctrl = this;
      $ctrl.isPwReveal = !$ctrl.isPwReveal;
    }
  
}

export default {
	bindings: {
        vendorId: '@'
	},
    controller: VendorApiKeyController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};